import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Events/GlobalFreightSummit2023/components/SectionFeatures/SectionFeatures.module.scss';

const cn = classNames.bind(styles);

const SectionFeatures = (): ReactElement => {
  return (
    <section className={cn('features')}>
      <div className={cn('container')}>
        <div className={cn('features__content-icons-box')}>
          <ul className={cn('features__content-icons')}>
            <li className={cn('features__content-icon')}>
              <img src="/images/pages/Events/icon-planet.svg" alt="icon" className="article-section__content-image" />
              <p className={cn('features__content-text')}>Worldwide attendees</p>
            </li>
            <li className={cn('features__content-icon')}>
              <img src="/images/pages/Events/icon-diamond.svg" alt="icon" className="article-section__content-image" />
              <p className={cn('features__content-text')}>First-class organization</p>
            </li>
            <li className={cn('features__content-icon')}>
              <img src="/images/pages/Events/icon-comment-cloud.svg" alt="icon" className="article-section__content-image" />
              <p className={cn('features__content-text')}>1-on-1 meetings</p>
            </li>
            <li className={cn('features__content-icon')}>
              <img src="/images/pages/Events/icon-circle.svg" alt="icon" className="article-section__content-image" />
              <p className={cn('features__content-text')}>Networking</p>
            </li>
            <li className={cn('features__content-icon')}>
              <img src="/images/pages/Events/icon-suitcase.svg" alt="icon" className="article-section__content-image" />
              <p className={cn('features__content-text')}>Experts</p>
            </li>
            <li className={cn('features__content-icon')}>
              <img src="/images/pages/Events/icon-ellipsis.svg" alt="icon" className="article-section__content-image" />
              <p className={cn('features__content-text')}>Much more</p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default SectionFeatures;